
import { defineComponent, computed, ref } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import InputGroupDark from '@/components/layout/InputGroupDark.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import Statuses from '@/components/others/Statuses.vue'
import MessageHistory from '@/components/others/MessageHistory.vue'
import JrButtonForJr from '@/components/jr-parts/JrButtonForJr.vue'
import JrButtonForJrqc from '@/components/jr-parts/JrButtonForJrqc.vue'
import ProximityInfo from '@/components/layout/ProximityInfo.vue'
import DateDisplay from '@/components/displays/DateDisplay.vue'
import UploadProximityFile from '@/components/inputs/UploadProximityFile.vue'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'
import GeneralAttachedFiles from '@/components/inputs/GeneralAttachedFiles.vue'

import { judgeDiscussion, priorDiscussion, discussionDocument, witness, answer, adversaria } from '@/constants/statuses'
import { useRoute } from 'vue-router'
import { RequestHeaderProximityForm } from '@/types/forms'
import { MessageGroups } from '@/constants/messageGroups'
import { MessageTypes } from '@/constants/messageTypes'
import { FileTypes, JR_UPLOAD_FILE_EXTS } from '@/constants/enums'
import {
  CreateGeneralAttachedFileApiRequest,
  DeleteGeneralAttachedFileApiRequest,
} from '@/requests/GeneralAttachedFile'
import { GeneralAttachedFilePost, GeneralAttachedFile } from '@/api'

/**
 * 近接工事申請件名詳細
 */
export default defineComponent({
  name: 'ProximityDetail',
  components: {
    InputGroupDark,
    DoubleScroll,
    Statuses,
    MessageHistory,
    JrButtonForJr,
    JrButtonForJrqc,
    UserLoginWrapper,
    ProximityInfo,
    DateDisplay,
    UploadProximityFile,
    JrApplicantTitle,
    GeneralAttachedFiles,
  },
  setup() {
    const route = useRoute()
    const requestHeaderId = computed(() => {
      return Number(route.params.request_header_id)
    })
    const detail = ref<RequestHeaderProximityForm | null>(null)
    // 回答履歴の更新用key
    const answerHistoryKey = ref<number>(0)
    // 覚書履歴の更新用key
    const adversariaHistoryKey = ref<number>(0)
    // 協議書履歴の更新用key
    const discussionDocumentHistoryKey = ref<number>(0)
    // 覚書・その他
    const generalAttachedFilesRef = ref<InstanceType<typeof GeneralAttachedFiles>>()

    // 覚書・その他 汎用添付ファイルを追加更新
    const updateGeneralAttachedFile = async (fileId: number) => {
      // requestの作成
      const GeneralAttachedFilePost: GeneralAttachedFilePost = {
        request_header: requestHeaderId.value,
        file: fileId,
      }
      const request = new CreateGeneralAttachedFileApiRequest(GeneralAttachedFilePost)
      // API実行
      await request.exec()
    }

    // 覚書・その他 汎用添付ファイルを削除更新
    const deleteGeneralAttachedFile = async (fileId: number) => {
      // requestの作成
      const GeneralAttachedFile: GeneralAttachedFile = {
        file: fileId,
      }
      const request = new DeleteGeneralAttachedFileApiRequest(GeneralAttachedFile)
      // API実行
      await request.exec()
    }

    return {
      requestHeaderId,
      judgeDiscussion,
      priorDiscussion,
      discussionDocument,
      witness,
      answer,
      adversaria,
      detail,
      MessageGroups,
      MessageTypes,
      FileTypes,
      answerHistoryKey,
      adversariaHistoryKey,
      discussionDocumentHistoryKey,
      allowExts: JR_UPLOAD_FILE_EXTS,
      generalAttachedFilesRef,
      updateGeneralAttachedFile,
      deleteGeneralAttachedFile,
    }
  },
})
